import React, { useEffect, useState } from "react";
import { partnersApi } from "@/lib/api";
import { PageShell } from "./Overview";
import { Star, ShieldCheck } from "lucide-react";

const PartnersPanel = () => {
  const [partners, setPartners] = useState([]);
  const [country, setCountry] = useState("");
  useEffect(() => { partnersApi.list(country || undefined).then(setPartners).catch(() => {}); }, [country]);

  return (
    <PageShell title="Partners" subtitle={`${partners.length} verified firms`}>
      <div className="flex gap-2 mb-6 flex-wrap" data-testid="partners-country-filter">
        {["", "IN", "US", "GB", "AE", "SG", "EE", "CH"].map((c) => (
          <button key={c || "all"} onClick={() => setCountry(c)}
            data-testid={`partners-filter-${c || "all"}`}
            className={`px-4 py-2 text-xs font-mono-accent uppercase tracking-[0.18em] border transition-colors ${
              country === c ? "border-artha-amber text-artha-amber" : "border-border-subtle text-ink-muted hover:text-ink-body"
            }`}>
            {c || "All"}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border-subtle border border-border-subtle">
        {partners.map((p) => (
          <div key={p.id} className="bg-surface-card p-6" data-testid={`partner-${p.id}`}>
            <div className="flex items-start justify-between">
              <div>
                <div className="text-xs font-mono-accent uppercase tracking-[0.2em] text-ink-muted">{p.country} · {p.city}</div>
                <div className="h-display text-xl mt-2">{p.name}</div>
              </div>
              {p.verified && <ShieldCheck size={16} className="text-artha-amber" />}
            </div>
            <div className="text-sm text-ink-muted mt-3">{p.specialization}</div>
            <div className="mt-6 pt-4 border-t border-border-subtle grid grid-cols-3 text-center gap-2">
              <Stat v={<span className="inline-flex items-center gap-1"><Star size={12} className="text-artha-amber fill-artha-amber" />{p.rating}</span>} l="Rating" />
              <Stat v={p.completed} l="Files" />
              <Stat v={`${p.sla_hours}h`} l="SLA" />
            </div>
          </div>
        ))}
      </div>
    </PageShell>
  );
};

const Stat = ({ v, l }) => (
  <div>
    <div className="font-mono-accent text-sm">{v}</div>
    <div className="text-[10px] uppercase tracking-[0.2em] font-mono-accent text-ink-muted mt-1">{l}</div>
  </div>
);

export default PartnersPanel;
